import { cn } from './cn'
import { t } from '@/lib/i18n'

export type LevelBadgeSize = 16 | 18 | 24 | 30

export interface LevelBadgeProps {
  level: number
  size?: LevelBadgeSize
  className?: string
  /** Hide from assistive tech when a parent already announces the level. */
  decorative?: boolean
}

const fontSizes: Record<LevelBadgeSize, string> = {
  16: 'text-[9px]',
  18: 'text-[10px]',
  24: 'text-[13px]',
  30: 'text-[16px]',
}

/** Circular level badge (REDESIGN section 9): bright blue fill (the level token), white numeral and a 2px surface ring. */
export function LevelBadge({ level, size = 18, className, decorative }: LevelBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full border-2 border-surface bg-level font-bold leading-none text-on-level tabular-nums select-none',
        fontSizes[size],
        className,
      )}
      style={{ width: size, height: size }}
      aria-label={decorative ? undefined : t('Level {level}', { level })}
      aria-hidden={decorative || undefined}
      role={decorative ? undefined : 'img'}
    >
      {level}
    </span>
  )
}
